import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import DoctorInfo from "./doctor.reducer";
import { History } from "history";

const index = (history: History) => {
  return combineReducers({
    router: connectRouter(history),
    doctorInfo: DoctorInfo,
  });
};

export default index;
